import React, { useEffect, useState } from 'react';
import { servicesAPI, siteSettingsAPI } from '../utils/api';
import { toast } from 'react-toastify';
import ConfirmModal from '../components/ConfirmModal';
import ServicesTable from '../components/ServicesTable';
import {
  Box,
  Typography,
  Paper,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Button,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

// Predefined services to import from CSV
const IMPORT_SERVICES = [
  { name: "Lips: Annual Top-up", price: 100, duration: 60, category: "Semi-Permanent MakeUp" },
  { name: "Brows: Annual Top-up", price: 100, duration: 60, category: "Semi-Permanent MakeUp" },
  { name: "Lips: First top-up (6 weeks)", price: 80, duration: 60, category: "Semi-Permanent MakeUp" },
  { name: "Brows: First top-up (6 weeks)", price: 80, duration: 60, category: "Semi-Permanent MakeUp" },
  { name: "Lip Blush", price: 250, duration: 120, category: "Semi-Permanent MakeUp" },
  { name: "Ombre Brows", price: 200, duration: 120, category: "Semi-Permanent MakeUp" },
  { name: "Powder Brows", price: 200, duration: 120, category: "Semi-Permanent MakeUp" },
  { name: "Microblading Brows", price: 200, duration: 120, category: "Semi-Permanent MakeUp" },
  { name: "Underarm (Armpit)", price: 15, duration: 15, category: "Body Waxing" },
  { name: "Hollywood", price: 35, duration: 40, category: "Body Waxing" },
  { name: "Brazilian", price: 30, duration: 35, category: "Body Waxing" },
  { name: "Bikini", price: 20, duration: 30, category: "Body Waxing" },
  { name: "Half Leg Wax", price: 15, duration: 30, category: "Body Waxing" },
  { name: "Mini Fill", price: 25, duration: 60, category: "Lash Extensions" },
  { name: "Lash Extension Removal", price: 15, duration: 30, category: "Lash Extensions" },
  { name: "Classic Infills", price: 35, duration: 90, category: "Lash Extensions" },
  { name: "Classic Lashes (full set)", price: 45, duration: 120, category: "Lash Extensions" },
  { name: "Dry Cut", price: 15, duration: 20, category: "Hair" },
  { name: "Nail Repair - From", price: 3, duration: 15, category: "Nails" },
  { name: "BIAB Infills", price: 35, duration: 75, category: "Nails" },
  { name: "BIAB Infills - With nail art", price: 40, duration: 90, category: "Nails" },
  { name: "Rebalance (4+ week infills)", price: 40, duration: 90, category: "Nails" },
  { name: "Rebalance + nail art", price: 45, duration: 105, category: "Nails" },
  { name: "Removal of Product", price: 10, duration: 25, category: "Nails" },
  { name: "Manicure", price: 20, duration: 40, category: "Nails" },
  { name: "2-week Gel Manicure", price: 25, duration: 45, category: "Nails" },
  { name: "2-week Gel Manicure + nail art", price: 30, duration: 60, category: "Nails" },
  { name: "BIAB Nails (Fresh set)", price: 35, duration: 60, category: "Nails" },
  { name: "BIAB Nails + nail art", price: 40, duration: 80, category: "Nails" },
  { name: "BIAB Nails + removal", price: 40, duration: 90, category: "Nails" },
  { name: "Builder Gel Nails", price: 35, duration: 90, category: "Nails" },
  { name: "Builder Gel + nail art", price: 40, duration: 90, category: "Nails" },
  { name: "Extensions - AcryGel", price: 40, duration: 90, category: "Nails" },
  { name: "Extensions - Builder Gel", price: 40, duration: 90, category: "Nails" },
  { name: "Extensions + nail art", price: 45, duration: 100, category: "Nails" },
  { name: "Infills (2-3 weeks)", price: 35, duration: 80, category: "Nails" },
  { name: "Infills + nail art", price: 40, duration: 90, category: "Nails" },
  { name: "Build a Toenail", price: 10, duration: 10, category: "Pedicure" },
  { name: "Gel Nails & Toes", price: 50, duration: 85, category: "Pedicure" },
  { name: "Luxury Pedicure", price: 45, duration: 90, category: "Pedicure" },
  { name: "Luxury Pedicure + removal", price: 50, duration: 95, category: "Pedicure" },
  { name: "Luxury Pedicure + nail art", price: 50, duration: 100, category: "Pedicure" },
  { name: "Gel Toes + Hard Skin Removal", price: 35, duration: 70, category: "Pedicure" },
  { name: "Gel Toes + removal", price: 40, duration: 75, category: "Pedicure" },
  { name: "Gel Toes + nail art", price: 40, duration: 75, category: "Pedicure" },
  { name: "Gel Toes", price: 25, duration: 45, category: "Pedicure" },
  { name: "Gel Toes + French", price: 30, duration: 50, category: "Pedicure" },
  { name: "HD Brows, Wax & Lamination", price: 45, duration: 45, category: "Brows" },
  { name: "HD Brows", price: 25, duration: 40, category: "Brows" },
  { name: "Eyebrow Lamination, Wax & Tint", price: 38, duration: 45, category: "Brows" },
  { name: "Eyebrow Lamination", price: 20, duration: 45, category: "Brows" },
  { name: "Eyebrow Wax & Tint", price: 18, duration: 15, category: "Brows" },
  { name: "Eyebrow Tint", price: 8, duration: 15, category: "Brows" },
  { name: "Eyebrow Waxing", price: 10, duration: 15, category: "Brows" },
  { name: "Lash Lift", price: 20, duration: 35, category: "Lashes" },
  { name: "Lash Tint", price: 12, duration: 20, category: "Lashes" },
  { name: "Lash Lift & Tint", price: 30, duration: 45, category: "Lashes" },
  { name: "Lip Wax", price: 8, duration: 15, category: "Facial Waxing" },
  { name: "Chin Wax", price: 8, duration: 15, category: "Facial Waxing" },
];

const AdminServices = () => {
  const [services, setServices] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [importing, setImporting] = useState(false);
  const [reorderMode, setReorderMode] = useState(false);
  const [categoryOrder, setCategoryOrder] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    duration: '',
    price: '',
    category: '',
    active: true
  });

  // Track whether user is typing a new category
  const [isNewCategory, setIsNewCategory] = useState(false);

  // Get unique categories from existing services + predefined defaults
  const defaultCategories = ['Brows', 'Nails', 'Feet', 'General'];
  const existingCategories = [...new Set(services.map(s => s.category).filter(Boolean))];
  const allCategories = [...new Set([...defaultCategories, ...existingCategories])].sort();

  // Get ordered categories for reorder mode - use custom order or alphabetical
  const getOrderedCategories = () => {
    const serviceCategories = [...new Set(services.map(s => s.category || 'General').filter(Boolean))];
    if (categoryOrder.length > 0) {
      // Sort by custom order, then alphabetically for unlisted
      return [...serviceCategories].sort((a, b) => {
        const aIndex = categoryOrder.indexOf(a);
        const bIndex = categoryOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
    }
    return serviceCategories.sort();
  };

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    serviceId: null,
    serviceName: '',
    loading: false
  });

  useEffect(() => {
    fetchServices();
    fetchCategoryOrder();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await servicesAPI.getAll();
      setServices(response.data);
    } catch (error) {
      toast.error('Failed to load services');
    }
  };

  const fetchCategoryOrder = async () => {
    try {
      const response = await siteSettingsAPI.getAll();
      if (response.data.category_order) {
        const order = typeof response.data.category_order === 'string'
          ? JSON.parse(response.data.category_order)
          : response.data.category_order;
        setCategoryOrder(order || []);
      }
    } catch (error) {
      console.error('Failed to fetch category order:', error);
    }
  };

  // Move category up or down in order
  const moveCategory = async (index, direction) => {
    const orderedCats = getOrderedCategories();
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= orderedCats.length) return;

    const newOrder = [...orderedCats];
    const [movedCat] = newOrder.splice(index, 1);
    newOrder.splice(newIndex, 0, movedCat);
    setCategoryOrder(newOrder);

    // Save to backend
    try {
      await siteSettingsAPI.updateSingle('category_order', JSON.stringify(newOrder));
      toast.success('Category order updated');
    } catch (error) {
      console.error('Error saving category order:', error);
      toast.error('Failed to save order');
      fetchCategoryOrder(); // Revert on error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingService) {
        await servicesAPI.update(editingService.id, formData);
        toast.success('Service updated successfully');
      } else {
        await servicesAPI.create(formData);
        toast.success('Service created successfully');
      }
      fetchServices();
      resetForm();
    } catch (error) {
      toast.error('Failed to save service');
    }
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setFormData({
      name: service.name,
      description: service.description || '',
      duration: service.duration,
      price: service.price,
      category: service.category || '',
      active: service.active
    });
    setShowForm(true);
    // Scroll to top so user sees the edit form on mobile
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = (service) => {
    setConfirmModal({
      isOpen: true,
      serviceId: service.id,
      serviceName: service.name,
      loading: false
    });
  };

  const confirmDelete = async () => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await servicesAPI.delete(confirmModal.serviceId);
      toast.success('Service deleted successfully');
      setConfirmModal({ isOpen: false, serviceId: null, serviceName: '', loading: false });
      fetchServices();
    } catch (error) {
      toast.error('Failed to delete service');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };

  const resetForm = () => {
    setFormData({ name: '', description: '', duration: '', price: '', category: '', active: true });
    setEditingService(null);
    setShowForm(false);
    setIsNewCategory(false);
  };

  const handleImportServices = async () => {
    if (importing) return;

    const confirmed = window.confirm(
      `This will import ${IMPORT_SERVICES.length} services from the predefined list.\n\n` +
      `Duplicates will be skipped automatically.\n\nContinue?`
    );

    if (!confirmed) return;

    setImporting(true);
    try {
      const response = await servicesAPI.bulkImport(IMPORT_SERVICES);
      const { summary } = response.data;

      if (summary.imported > 0) {
        toast.success(`Imported ${summary.imported} services! (${summary.skipped} skipped)`);
      } else {
        toast.info(`No new services imported. ${summary.skipped} already exist.`);
      }

      fetchServices();
    } catch (error) {
      console.error('Import error:', error);
      toast.error('Failed to import services');
    } finally {
      setImporting(false);
    }
  };


  return (
    <div>
      <div className="card">
        <div className="card-header" style={{ flexWrap: 'wrap', gap: '0.75rem' }}>
          <h2>Manage Services</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <button
              onClick={() => setReorderMode(!reorderMode)}
              className={`btn ${reorderMode ? 'btn-success' : 'btn-secondary'}`}
              style={{ whiteSpace: 'nowrap' }}
            >
              {reorderMode ? '✓ Done' : '↕ Reorder'}
            </button>
            <button
              onClick={handleImportServices}
              className="btn btn-secondary"
              disabled={importing || reorderMode}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', whiteSpace: 'nowrap' }}
            >
              {importing ? 'Importing...' : '📥 Import'}
            </button>
            <button
              onClick={() => setShowForm(!showForm)}
              className="btn btn-primary"
              disabled={reorderMode}
              style={{ whiteSpace: 'nowrap' }}
            >
              {showForm ? 'Cancel' : '+ Add'}
            </button>
          </div>
        </div>

        {showForm && (
          <form onSubmit={handleSubmit} style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '8px' }}>
            <div className="grid grid-2">
              <div className="form-group">
                <label>Service Name *</label>
                <input type="text" className="form-control" value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Duration (minutes) *</label>
                <input type="number" className="form-control" value={formData.duration}
                  onChange={(e) => setFormData({...formData, duration: e.target.value})} required />
              </div>
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea className="form-control" value={formData.description} rows="3"
                onChange={(e) => setFormData({...formData, description: e.target.value})} />
            </div>
            <div className="grid grid-2">
              <div className="form-group">
                <label>Category (for Loyalty Stamps)</label>
                {!isNewCategory ? (
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <select
                      className="form-control"
                      value={formData.category}
                      onChange={(e) => {
                        if (e.target.value === '__new__') {
                          setIsNewCategory(true);
                          setFormData({...formData, category: ''});
                        } else {
                          setFormData({...formData, category: e.target.value});
                        }
                      }}
                      style={{ flex: 1 }}
                    >
                      <option value="">Select a category...</option>
                      {allCategories.map(cat => (
                        <option key={cat} value={cat}>{cat}</option>
                      ))}
                      <option value="__new__">+ Create new category...</option>
                    </select>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.category}
                      onChange={(e) => setFormData({...formData, category: e.target.value})}
                      placeholder="Enter new category name"
                      autoFocus
                      style={{ flex: 1 }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setIsNewCategory(false);
                        setFormData({...formData, category: ''});
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Price (£) *</label>
                <input type="number" step="0.01" className="form-control" value={formData.price}
                  onChange={(e) => setFormData({...formData, price: e.target.value})} required />
              </div>
            </div>
            <div className="form-group" style={{ marginTop: '0.5rem' }}>
              <label>
                <input type="checkbox" checked={formData.active}
                  onChange={(e) => setFormData({...formData, active: e.target.checked})} />
                {' '}Active
              </label>
            </div>
            <button type="submit" className="btn btn-success">
              {editingService ? 'Update Service' : 'Create Service'}
            </button>
          </form>
        )}

        {reorderMode ? (
          <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <DragIndicatorIcon /> Reorder Categories
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Set the display order for service categories on the booking page. Services will be grouped under these categories.
            </Typography>
            <List>
              {getOrderedCategories().map((category, index) => {
                const categoryServices = services.filter(s => (s.category || 'General') === category);
                return (
                  <ListItem
                    key={category}
                    sx={{
                      bgcolor: 'background.paper',
                      mb: 1,
                      borderRadius: 1,
                      border: '1px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          bgcolor: 'primary.main',
                          color: 'white',
                          px: 1,
                          py: 0.25,
                          borderRadius: 1,
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: 'center',
                        }}
                      >
                        {index + 1}
                      </Typography>
                    </Box>
                    <ListItemText
                      primary={category}
                      secondary={`${categoryServices.length} service${categoryServices.length !== 1 ? 's' : ''}`}
                    />
                    <ListItemSecondaryAction>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <IconButton
                          size="small"
                          onClick={() => moveCategory(index, 'up')}
                          disabled={index === 0}
                          sx={{ bgcolor: 'action.hover' }}
                        >
                          <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => moveCategory(index, 'down')}
                          disabled={index === getOrderedCategories().length - 1}
                          sx={{ bgcolor: 'action.hover' }}
                        >
                          <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        ) : (
          <ServicesTable
            services={services}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        )}
      </div>

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title="Delete Service"
        message={`Are you sure you want to delete "${confirmModal.serviceName}"? This cannot be undone.`}
        confirmText="Delete"
        confirmStyle="danger"
        onConfirm={confirmDelete}
        onCancel={() => setConfirmModal({ isOpen: false, serviceId: null, serviceName: '', loading: false })}
        loading={confirmModal.loading}
      />
    </div>
  );
};

export default AdminServices;
